import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import CheckoutStepFormContext from "../CheckoutStepFormContext";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import { Form, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  AllCity,
  allGoogleLocations,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrderAddress,
  EditOrderAddress,
  getAllOrderAddress,
  getSingleOrderAddress,
  OrderCalculation,
} from "../../../../features/order/orderSlice";
import { Next } from "react-bootstrap/esm/PageItem";
import { deleteUserAddress } from "../../../../features/user/userSlice";
import Light_Gray_Outline_Btn from "../../../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn";
import { Navigate, useNavigate } from "react-router-dom";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Orange_Btn from "../../../common-components/common_btn/orange_btn/Orange_Btn";

const countryOptions = [
  { value: "in", label: "India" },
  { value: "us", label: "United States" },
];

const stateOptions = [
  { value: "maharashtra", label: "Maharashtra" },
  { value: "karnataka", label: "Karnataka" },
];

const Details = ({ selectedAddressId, setSelectedAddressId }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // use "auto" for instant scrolling
    });
  }, []);
  const dispatch = useDispatch();
  const { details, setDetails, next } = useContext(CheckoutStepFormContext);
  const [showTextarea, setShowTextarea] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
  const [selectednewAddressId, setSelectednewAddressId] = useState(null);

  const allplaces = useSelector((state) => state.master.places);

  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search && search.trim().length >= 2) {
        dispatch(allGoogleLocations(search));
        setShowDropdown(true);
      } else {
        setShowDropdown(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [search, dispatch]);

  const {
    control,
    handleSubmit,
    register,
    getValues,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      // name: details.name || "",
      // pincode: details.pincode || "",
      // addressLine1: details.addressLine1 || "",
      // addressLine2: details.addressLine2 || "",
      // landmark: details.landmark || "",
      // city: details.city || "",
      // country: details.country || null,
      // state: details.state || null,
      // defaultAddress: details.defaultAddress || false,
      // instructions: details.instructions || "",
      // contact: details.contact || "",
    },
  });

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const handleCountryChange = (selectedOption) => {
    setValue("country_id", selectedOption?.value);
    setValue("state_id", null);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllState({ countryId: selectedOption.value }));
  };

  const handleStateChange = (selectedOption) => {
    setValue("state_id", selectedOption.value);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllCity({ stateId: selectedOption.value }));
  };

  const handleCityChange = (selectedOption) => {
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    setValue("pincode_id", selectedOption?.value);
  };

  const onSubmit = async (data) => {
    setAddressError("");
    const DataToSend = new FormData();
    DataToSend.append("country_id", data?.country_id);
    DataToSend.append("state_id", data?.state_id);
    DataToSend.append("lat", data?.lat);
    DataToSend.append("long", data?.long);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id);
    DataToSend.append("street", data?.street);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.landmark);
    DataToSend.append("delivery_instruction", data?.delivery_instruction);
    const res = await dispatch(createOrderAddress({ data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSuccessModal(true);
      setIsEdit(false);
      reset();
      await setSelectedAddressId(res.payload?.data?.id);
      await dispatch(getAllOrderAddress());

      window.scrollTo({
        top: 0,
        behavior: "smooth", // use "auto" for instant scrolling
      });

      next();
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const handleUpdate = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("lat", data?.lat);
    DataToSend.append("long", data?.long);
    DataToSend.append("country_id", data?.country_id);
    DataToSend.append("state_id", data?.state_id);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id);
    DataToSend.append("street", data?.street);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.landmark);
    DataToSend.append("delivery_instruction", data?.delivery_instruction);
    const res = await dispatch(EditOrderAddress({ id, data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSuccessModal(true);
      dispatch(getAllOrderAddress());

      window.scrollTo({
        top: 0,
        behavior: "smooth", // use "auto" for instant scrolling
      });
    } else if (res.meta?.requestStatus === "rejected") {
    }
    setIsEdit(false);
    reset();
  };
  const [isEdit, setIsEdit] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const allAddress = useSelector((state) => state.order.allOrdersAddress);

  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, [dispatch]);

  useEffect(() => {
    if (!selectedAddressId && allAddress?.data?.length > 0) {
      setSelectedAddressId(allAddress.data[0].id);
    }
  }, [allAddress]);

  // const handleDelete = async (id) => {
  //   await dispatch(deleteUserAddress(id));

  //   if (selectedAddressId === id) {
  //     setSelectedAddressId(null);
  //   }

  //   await dispatch(getAllOrderAddress());
  // };

  const handleDelete = async () => {
    const res = await dispatch(deleteUserAddress(selectednewAddressId));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllOrderAddress());

      setShowDeleteModal(false);
      setShowDeleteSuccessModal(true);
      setSelectedAddressId(null);
    }
  };

  const [id, setId] = useState();

  const handleEdit = async (data) => {
    const res = await dispatch(getSingleOrderAddress({ id: data.id }));
    const address = res?.payload?.data;
    setId(data.id);

    // await dispatch(AllState({ countryId: address.country_id }));
    // await dispatch(AllCity({ stateId: address.state_id }));
    // await dispatch(AllPincode({ cityId: address.city_id }));

    reset(address);

    setIsUpdate(true);
    setIsEdit(true);
  };

  const handleAdd = () => {
    setIsUpdate(false);
    setId(null);

    reset({
      country_id: null,
      state_id: null,
      city_id: null,
      pincode_id: null,
      name: "",
      building: "",
      street: "",
      landmark: "",
      contact_no: "",
      delivery_instruction: "",
    });

    setAddressError("");
    setIsEdit(true);
  };

  const handleCancel = async () => {
    setIsEdit(false);
    setIsUpdate(false);
    setId(null);

    window.scrollTo({
      top: 0,
      behavior: "smooth", // use "auto" for instant scrolling
    });

    reset({
      country_id: null,
      state_id: null,
      city_id: null,
      pincode_id: null,
      name: "",
      building: "",
      street: "",
      landmark: "",
      contact_no: "",
      delivery_instruction: "",
    });

    setAddressError("");

    await dispatch(getAllOrderAddress());
  };

  const [addressError, setAddressError] = useState("");
  console.log(selectedAddressId, "selectedAddressId selectedAddressId");

  const [loading, setLoading] = useState(false);

  const handleNext = async () => {
    if (!selectedAddressId) {
      setAddressError("Please select an address.");
      return;
    }

    try {
      setLoading(true);
      setAddressError("");

      const res = await dispatch(
        OrderCalculation({
          address_id: selectedAddressId,
        }),
      );

      if (res.meta.requestStatus === "fulfilled") {
        next();
      } else {
        setAddressError(
          res.payload?.errors ||
            "Sorry! Delivery is currently unavailable for this pincode.",
        );
      }
    } catch (error) {
      setAddressError(
        error?.response?.data?.errors ||
          "Sorry! Delivery is currently unavailable for this pincode.",
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleNext = () => {
  //   if (allAddress?.data?.length > 0) {
  //     setAddressError(""); // Clear error
  //     next(); // Proceed
  //   } else {
  //     setAddressError("Please add an address before continuing.");
  //   }
  // };

  useEffect(() => {
    if (selectedAddressId) {
      setSelectedAddressId(selectedAddressId);
    } else if (allAddress?.data?.length > 0) {
      setSelectedAddressId(allAddress.data[0].id);
    }
  }, [allAddress?.data]);

  const navigate = useNavigate();
  return (
    <>
      <div className="add_address_radio_box">
        <h4>Your Saved Address</h4>

        <div className="row">
          {allAddress?.data?.map((val, index) => {
            const parts = [
              val?.building,
              val?.street,
              val?.apartment,
              val?.Users_Address_Detail?.Country?.name,
              val?.Users_Address_Detail?.State?.name,
              val?.Users_Address_Detail?.City?.name,
              val?.Users_Address_Detail?.Pincode?.name,
            ];
            const fullAddress = parts.filter(Boolean).join(", ");

            return (
              <div
                className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-2"
                key={val.id || index}
              >
                <div className="address_radio_box_holder">
                  <Form.Check
                    inline
                    label={fullAddress}
                    name="group1"
                    type="radio"
                    value={val?.id}
                    checked={selectedAddressId === val.id}
                    onChange={() => setSelectedAddressId(val.id)}
                  />

                  <div className="icons_holder">
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="edit_icon"
                        onClick={() => {
                          handleEdit(val);
                        }}
                      />
                    </div>
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="delete_icon"
                        // onClick={() => {
                        //   handleDelete(val.id);
                        // }}
                        onClick={() => {
                          setSelectednewAddressId(val.id);
                          setShowDeleteModal(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          {/* <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 mb-2">
            <div className="address_radio_box_holder">
              <Form.Check
                inline
                label="Flat No. 502, Orchid Towers Koregaon Park Road Pune, Maharashtra 411001 India"
                name="group1"
                type="radio"
              />
            </div>
          </div> */}
        </div>

        <div className="form_footer">
          <p className="add_address_text" onClick={handleAdd}>
            Add Address
          </p>
        </div>
      </div>
      {isEdit && (
        <>
          <Form className="details__wrapper ">
            <div className="row">
              <div className="col-12">
                <Form.Group
                  className={`form__item input_group ${
                    errors.name ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    placeholder="Enter Full Name"
                    {...register("name", {
                      required: "Full name is required",

                      maxLength: {
                        value: 60,
                        message: "Full name cannot exceed 60 characters",
                      },
                    })}
                    onChange={(e) => {
                      setValue("name", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                  />
                  {errors.name && (
                    <p className="error__feedback">{errors.name.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group className="form__item input_group position-relative">
                  <Form.Label>Address *</Form.Label>

                  <Form.Control
                    placeholder="Enter Area"
                    value={search}
                    {...register("building", {
                      required: "Area is required",
                    })}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearch(value);
                      setValue("building", value, {
                        shouldValidate: true,
                      });
                    }}
                  />

                  {errors.building && (
                    <p className="error__feedback">{errors.building.message}</p>
                  )}

                  {showDropdown && allplaces?.length > 0 && (
                    <div
                      className="position-absolute bg-white border rounded shadow w-100"
                      style={{
                        zIndex: 1000,
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}
                    >
                      {allplaces.map((place) => (
                        <div
                          key={place.place_id}
                          className="p-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSearch(place.description);
                            setValue("building", place.address, {
                              shouldValidate: true,
                            });

                            // Optional: fill other fields
                            setValue("city_id", place.city);
                            setValue("state_id", place.state);
                            setValue("country_id", place.country);
                            setValue("pincode_id", place.pincode);
                            setValue("lat", place.location.lat);
                            setValue("long", place.location.lng);

                            setShowDropdown(false);
                          }}
                        >
                          {place.address}
                        </div>
                      ))}
                    </div>
                  )}
                </Form.Group>
              </div>

               <div className="col-12">
                <Form.Group className="form__item input_group">
                  <Form.Label>Apartment</Form.Label>
                  <Form.Control
                    {...register("street")}
                    placeholder="Enter Apartment"
                    onChange={(e) => {
                      setValue("street", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Group className="form__item input_group">
                  <Form.Label>Landmark</Form.Label>
                  <Form.Control
                    {...register("landmark")}
                    onChange={(e) => {
                      setValue("landmark", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                    placeholder="Enter Landmark"
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.country ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Country / Region *</Form.Label>
                  <Form.Control
                    {...register("country_id", {
                      required: "Country is required",
                    })}
                    placeholder="Country"
                  />
                  {/* <Controller
                    className="Select_Dropdown_holder"
                    name="country_id" // Form field name
                    control={control}
                    rules={{ required: "Country is required" }}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={countries}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          // GetAllStates(selectedOption.value);
                          handleCountryChange(selectedOption);
                          clearErrors("country_id");
                          setValue("country_id", selectedOption);
                          // setValue("state_id", null);
                          // setValue("city_id", null);
                        }}
                      />
                    )}
                  /> */}
                  {errors.country_id && (
                    <p className="error__feedback">
                      {errors.country_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.state ? "input__error" : ""
                  }`}
                >
                  <Form.Label>State *</Form.Label>
                  <Form.Control
                    {...register("state_id", {
                      required: "State is required",
                    })}
                    placeholder="State"
                  />
                  {/* <Controller
                    className="Select_Dropdown_holder"
                    name="state_id" // Form field name
                    control={control}
                    rules={{ required: "State is required" }}
                    render={({ field }) => (
                      // <Select
                      //   className="Select_Dropdown_holder__select"
                      //   classNamePrefix="custom-select"
                      //   placeholder="State"
                      //   options={states}

                      //   onChange={(val) => {
                      //     field.onChange(val); // update form
                      //     handleStateChange(val); // your custom logic
                      //   }}
                      // />
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={states}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          handleStateChange(selectedOption);
                          setValue("state_id", selectedOption);
                          setValue("city_id", null);
                          // clearErrors("country_id");
                          clearErrors("state_id");
                        }}
                      />
                    )}
                  /> */}
                  {errors.state_id && (
                    <p className="error__feedback">{errors.state_id.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.city ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Town / City *</Form.Label>
                  <Form.Control
                    {...register("city_id", {
                      required: "City is required",
                    })}
                    placeholder="City"
                  />
                  {/* <Controller
                    className="Select_Dropdown_holder"
                    name="city_id" // Form field name
                    control={control}
                    rules={{ required: "City is required" }}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={cities}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          handleCityChange(selectedOption);
                          setValue("city_id", selectedOption);
                          // setValue("city_id", null);
                          clearErrors("city_id");
                        }}
                      />
                    )}
                  /> */}
                  {errors.city_id && (
                    <p className="error__feedback">{errors.city_id.message}</p>
                  )}
                </Form.Group>
              </div>
                  
              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.pincode ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Pincode *</Form.Label>
                  <Form.Control
                    {...register("pincode_id", {
                      required: "Pincode is required",
                    })}
                    placeholder="Pincode"
                  />
                  {/* <Controller
                    className="Select_Dropdown_holder"
                    name="pincode_id" // Form field name
                    control={control}
                    rules={{ required: "Pincode is required" }}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={pincodes}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          handlePincodeChange(selectedOption);
                          clearErrors("pincode_id");
                          setValue("pincode_id", selectedOption);
                        }}
                      />
                    )}
                  /> */}
                  {errors.pincode_id && (
                    <p className="error__feedback">
                      {errors.pincode_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form__item input_group">
                  <Form.Label>Contact *</Form.Label>
                  <Controller
                    name="contact_no"
                    control={control}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault(); // Block non-numeric input
                      }
                    }}
                    rules={{
                      required: "Contact is required",

                      minLength: {
                        value: 12,
                        message: "Mobile number must be 10 digits",
                      },
                      maxLength: {
                        value: 12,
                        message: "Mobile number must be 10 digits",
                      },
                      pattern: {
                        value: /^[6-9]\d{11}$/,
                        message: "Enter valid 10-digit contact number",
                      },
                    }}
                    onChange={(e) => {
                      setValue("contact_no", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        {...field}
                        country="in"
                        onChange={(value) => field.onChange(value)}
                        inputClass="form-control"
                      />
                    )}
                  />
                  {errors.contact_no && (
                    <p className="error__feedback">
                      {errors.contact_no.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              {/* <div className="col-12">
                <Form.Group
                  className={`form__item input_group ${
                    errors.addressLine1 ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Area *</Form.Label>
                  <Form.Control
                    placeholder="Enter Flat, House No., Building, Company"
                    {...register("building", {
                      required: "Address line is required",
                    })}
                    onChange={(e) => {
                      setValue("building", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                  />
                  {errors.building && (
                    <p className="error__feedback">{errors.building.message}</p>
                  )}
                </Form.Group>
              </div> */}

              {/* <div className="col-12">
                <Form.Group className="form__item input_group">
                  <Form.Label>Apartment</Form.Label>
                  <Form.Control
                    {...register("street")}
                    placeholder="Enter Apartment"
                    onChange={(e) => {
                      setValue("street", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Group className="form__item input_group">
                  <Form.Label>Landmark</Form.Label>
                  <Form.Control
                    {...register("landmark")}
                    onChange={(e) => {
                      setValue("landmark", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                    placeholder="Enter Landmark"
                  />
                </Form.Group>
              </div> */}
              {/* 
          <div className="col-12">
            <Form.Group className="input_group">
              <Form.Check
                type="checkbox"
                label="Make this my default address"
                {...register("defaultAddress")}
              />
            </Form.Group>
          </div> */}

              <div className="col-12">
                <Form.Group className="input_group">
                  <Form.Label>Delivery Instructions (Optional)</Form.Label>
                  <div
                    onClick={() => setShowTextarea(!showTextarea)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="note__text">
                      Add Preferences, Notes, Access Codes And More{" "}
                      <FontAwesomeIcon
                        className="text-muted"
                        icon={showTextarea ? faAngleUp : faAngleDown}
                      />
                    </span>
                  </div>

                  {showTextarea && (
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...register("delivery_instruction")}
                    />
                  )}
                </Form.Group>
              </div>
            </div>

            <div className="form__item button__items d-flex justify-content-center">
              <div className="save_btn">
                <Green_Outline_Btn btnText="Cancel" onClick={handleCancel} />
              </div>

              <div className="cancel_btn">
                {isUpdate ? (
                  <Green_Outline_Btn
                    btnText="Update"
                    onClick={handleSubmit(handleUpdate)}
                  />
                ) : (
                  <Green_Outline_Btn
                    btnText="Save & Next"
                    onClick={handleSubmit(onSubmit)}
                  />
                )}
              </div>
            </div>
          </Form>
        </>
      )}
      {!isEdit && (
        <>
          {addressError && (
            <div className="alert alert-danger mb-3">{addressError}</div>
          )}
          <div className="form__item back_next_btn button__items d-flex justify-content-center align-items-center mb-3">
            <Green_Outline_Btn
              btnText="Back"
              onClick={() => navigate("/product-cart")}
            />
            <Green_Outline_Btn btnText="Next" onClick={handleNext} />
            {/* {addressError && <p className="text-danger mt-2">{addressError}</p>} */}
          </div>
        </>
      )}

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText={
          isUpdate
            ? "Address Updated Successfully!"
            : "Address Added Successfully!"
        }
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        className="Cancel_Reason_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this address?</Modal.Body>

        <Modal.Footer>
          <div className="btns_holder">
            <Green_btn
              btnText={"No"}
              onClick={() => setShowDeleteModal(false)}
            />

            <Orange_Btn btnText={"Yes"} onClick={handleDelete} />
          </div>
        </Modal.Footer>
      </Modal>

      <Success_Modal
        show={showDeleteSuccessModal}
        onHide={() => setShowDeleteSuccessModal(false)}
        successText="Address deleted successfully!"
      />
    </>
  );
};

export default Details;
